export const certifiedTextContent = {
  subtitleText: "Certified Excellence",
  certifiedContent: [
    {
      imageContent: [
        { imageSrc: "/assets/stock-img/certificate_logo_01.webp" },
        { imageSrc: "/assets/stock-img/certificate_logo_02.webp" },
        { imageSrc: "/assets/stock-img/certificate_logo_03.webp" },
        { imageSrc: "/assets/stock-img/certificate_logo_04.webp" },
        { imageSrc: "/assets/stock-img/certificate_logo_05.webp" },
        { imageSrc: "/assets/stock-img/certificate_logo_06.webp" },
        { imageSrc: "/assets/stock-img/certificate_logo_07.webp" },
        { imageSrc: "/assets/stock-img/certificate_logo_01.webp" },
        { imageSrc: "/assets/stock-img/certificate_logo_02.webp" },
        { imageSrc: "/assets/stock-img/certificate_logo_03.webp" },
        { imageSrc: "/assets/stock-img/certificate_logo_04.webp" },
        { imageSrc: "/assets/stock-img/certificate_logo_05.webp" },
        { imageSrc: "/assets/stock-img/certificate_logo_06.webp" },
        { imageSrc: "/assets/stock-img/certificate_logo_07.webp" },
      ],
    },
  ],
};
